interface AuthLayoutProps {
  title?: string;
  subtitle?: string;
  message?: string;
  isError?: boolean;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export function AuthLayout({ title, subtitle, message, isError, footer, children }: AuthLayoutProps) {
  return (
    <div className="auth-shell">
      <div className="auth-panel">
        <div className="auth-brand">Kingfisher</div>
        {title && <h1>{title}</h1>}
        {subtitle && <p className="auth-subtitle">{subtitle}</p>}
        {message && (
          <div className={isError ? 'flash error' : 'flash'}>{message}</div>
        )}
        {children}
        {footer && <div className="auth-footer">{footer}</div>}
      </div>
    </div>
  );
}
